import { Injectable } from '@angular/core';

@Injectable()
export class StandardTableProvider {
	private stdTable: string;

	public get standardTable(): string {
		return this.stdTable;
	}

	public set standardTableName(stdTable: string) {
		this.stdTable = stdTable;
	}
}
